import React, {Component} from 'react';
import {
    Platform,
    StyleSheet,
    Text,
    View,
    ScrollView,
    TouchableOpacity,
    ImageBackground,
    Image,
    Dimensions,
    ActivityIndicator
} from 'react-native';
import {connect} from "react-redux";
import HMTextView from "./HMTextView";
import {moderateScale} from "../tools/Scaling";
import Colors from "../tools/Colors";

//import FastImage from "react-native-fast-image";
import {typeExport} from "../redux/store/type";
import FastImage from "../importCalss/FastImage";

const images = [], imgWidth = 7,
    winWidth = Dimensions.get('window').width,
    winHeight = Dimensions.get('window').height

class HMImageView extends Component {

    state = {
        source: null,
        loadImage: false
    };

    constructor(props) {
        super(props);
        // if (Platform.OS != 'web'){
        //     alert("cgbnbbcvcvc")
        //     FastImage = require("react-native-fast-image")
        //
        // }
    }

    componentDidMount() {

        // this.DownlodFile()
    }

    /*    loadFile = async (path, type) => {
            // this.setState({source: {uri: path}});
            /!*  if (type == 'background') {
                  await AsyngStorageClass.setImageBackground(path)
              }
              else {
                  await AsyngStorageClass.setImageSplash(path)
              }
      *!/
            this.path(path)

        }*/

    path(path) {
        this.setState({
                source: path
            },
            () => {

                //     this.DownlodFile()

            })
    }


    /*  CalldownloadFile = (uri, path) => {

          if (uri && uri.length > 0 && uri.trim() !== "")
              RNFS.downloadFile({fromUrl: uri, toFile: path}).promise
                  .then(res => this.loadFile(path)).catch(e => {
                  this.path(uri)


              })
          else
              this.path(uri)
      }*/

    /*    DownlodFile() {
            const uri = this.props.uriComplete ? this.props.uriComplete : typeExport.baseUrlImage + this.props.uri;
            const name = shorthash.unique(uri);
            const extension = (Platform.OS === 'android') ? 'file://' : '';
            const path = `${extension}${RNFS.CachesDirectoryPath}/${name}.jpg`;

            RNFS.exists(path).then(exists => {
                //  alert("ss")
                if (exists) this.loadFile(path);
                else this.CalldownloadFile(uri, path);
            }).catch(e => {

                this.path(uri)


            })
        }*/

    render() {
        const {tintColor, imageChild, style, styleImageRoot, styleTextRoot, card, source_image, onLoad, onError, _backgroundColor, _backgroundColorLoading, requireData, NotBgColor, resizeMode, borderRadius, styleRoot, styleImage, styleShadoBackground, styleText, text, styleTextChild, textChild, uriComplete, icon, navigateParams, item, onPress, uri} = this.props;
        // let data = this.props.DataSplashScreen.results.advertises

        return (
            <View style={{
                //  position: 'relative',
                width: "100%",
                height: "100%",
            }}>
                {
                    card && item.card ?
                        <View
                            style={[style, {
                                width: "100%",
                                height: "100%",
                                alignSelf: 'center',
                                //padding:moderateScale(2)
                                //backgroundColor:'#ee15ae'
                            }]}>

                            <View style={{
                                flex: 1,
                                //height:  moderateScale(100),
                                padding: moderateScale(4),
                                borderWidth: moderateScale(1),
                                borderRadius: moderateScale(2),
                                borderColor: '#ddd',
                                borderBottomWidth: 0,
                                shadowColor: '#000',
                                shadowOffset: {width: 0, height: moderateScale(.8)},
                                shadowOpacity: 0.6,
                                shadowRadius: moderateScale(2),
                                elevation: moderateScale(1),
                                marginLeft: moderateScale(1),
                                marginRight: moderateScale(1),
                                marginTop: moderateScale(1),
                                marginBottom: moderateScale(1),
                                backgroundColor: item.background_color ? item.background_color : Colors.white,
                            }}>
                                <View
                                    style={[{flex: text && text != null && text.length > 0 ? .72 : 1,}, styleImageRoot,]}>
                                    {
                                        FastImage ?
                                            <FastImage
                                                onLoad={onLoad}
                                                onError={onError}
                                                // style={styles.image}
                                                tintColor={tintColor}

                                                style={[{
                                                    //   backgroundColor:'#eee831',
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: borderRadius ? moderateScale(borderRadius) : 0,
                                                    backgroundColor: this.state.loadImage ? Colors.transparent : _backgroundColorLoading ? _backgroundColorLoading : Colors.gray
                                                }, styleImage]}
                                                onLoadEnd={(e) => {
                                                    this.setState({
                                                        loadImage: true
                                                    })
                                                }
                                                }
                                                resizeMode={resizeMode ? resizeMode : FastImage.resizeMode.contain}
                                                source={source_image ? source_image : {uri: this.props.uriComplete ? this.props.uriComplete : this.props.uriComplete == '' || this.props.uriComplete == null ? null : typeExport.baseUrlImage + this.props.uri}}
                                            />
                                            :
                                            <Image
                                                source={source_image ? source_image : {uri: this.props.uriComplete ? this.props.uriComplete : this.props.uriComplete == '' || this.props.uriComplete == null ? null : typeExport.baseUrlImage + this.props.uri}}
                                                resizeMode={resizeMode ? resizeMode : "contain"}
                                                tintColor={tintColor}

                                                style={[{
                                                    //   backgroundColor:'#eee831',
                                                    width: "100%",
                                                    height: "100%",
                                                    borderRadius: borderRadius ? moderateScale(borderRadius) : 0,
                                                    backgroundColor: this.state.loadImage ? Colors.transparent : _backgroundColorLoading ? _backgroundColorLoading : Colors.gray
                                                }, styleImage]}

                                            />

                                    }
                                    {
                                        imageChild ?
                                            <View
                                                style={{

                                                    position: 'absolute',
                                                    bottom: 0,
                                                    // left: "50%",
                                                    //   margin: moderateScale(2),
                                                    // width: moderateScale(14),
                                                    // height: moderateScale(14),
                                                    zIndex: 11,
                                                    alignSelf: 'center',

                                                }}>
                                                <Image
                                                    source={imageChild}
                                                    //resizeMode="stretch"
                                                    style={[{}, {


                                                        //   margin: moderateScale(5),
                                                        width: moderateScale(14),
                                                        height: moderateScale(14),


                                                    }]}/>
                                            </View>
                                            :
                                            null
                                    }
                                </View>
                                {
                                    text && text != null && text.length > 0 ?
                                        <View style={[{flex: .28,}, styleTextRoot,]}>
                                            <HMTextView type={"bold"}

                                                        style={[


                                                            {
                                                                width: '100%',
                                                                fontSize: moderateScale(14),
                                                                color: item.font_color ? item.font_color : Colors.white,

                                                                textAlign: 'center'
                                                            },
                                                            styleText,
                                                        ]}

                                                        text={text}
                                            />
                                            {
                                                textChild && textChild != null && textChild.length > 0 ?

                                                    <HMTextView
                                                        cammas
                                                        type={"bold"}

                                                        style={[


                                                            {
                                                                width: '100%',
                                                                fontSize: moderateScale(14),
                                                                color: item.font_color ? item.font_color : Colors.white,

                                                                textAlign: 'center'
                                                            },
                                                            styleTextChild,
                                                        ]}

                                                        text={textChild}
                                                    />

                                                    : null
                                            }

                                        </View>
                                        : null
                                }
                            </View>

                        </View>
                        :
                        <View
                            style={[styleRoot, {
                                position: 'relative',
                                width: "100%",
                                height: "100%",
                                // justifyContent: 'center',
                                //  alignItems: 'center',
                                //   borderRadius:moderateScale(10)
                            }]}>
                            {/*<Image
                    source={this.props.DataSplashScreen.Background !== null ? {uri: this.props.DataSplashScreen.Background} : PathFile.image.background}
                    resizeMode="stretch"
                    style={[{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}, {
                        width: "100%",
                        height: "100%"
                    }]}/>*/}

                            {/*   <CacheableImage
                    resizeMode="cover"
                    style={[styleImage, {position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}, {
                        width: "100%",
                        height: "100%",

                    }]}
                    source={{uri:typeExport.baseUrlImage + uri}}
                >
                </CacheableImage>*/}

                            {
                                NotBgColor ?
                                    null
                                    :
                                    <View style={[styleShadoBackground, {
                                        //...StyleSheet.absoluteFillObject,
                                        //backgroundColor:_backgroundColor?_backgroundColor: 'rgba(0,0,0,0.25)',
                                        backgroundColor: _backgroundColor ? _backgroundColor : Colors.transparent,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        //  margin: moderateScale(6),
                                        width: "100%",
                                        height: "100%",
                                        top: 0, bottom: 0, left: 0, right: 0,
                                        borderRadius: borderRadius ? moderateScale(borderRadius) : 0

                                    }]}>

                                    </View>
                            }
                            {
                                //this.state.source === null ?
                                1 !== 1 ?

                                    <View style={{
                                        width: "100%",
                                        height: "100%",
                                        position: 'absolute',
                                        top: 0,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        alignItems: 'center',
                                        justifyContent: 'center'

                                    }}>
                                        <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                                    </View>

                                    //
                                    //     {/*<SvgUri
                                    //     width={moderateScale(20)}
                                    //     height={moderateScale(20)}
                                    //     style={{marginHorizontal: moderateScale(3), color: Colors.red, alignItems: 'center'}}
                                    //     source={PathFile.svg.default}
                                    //     //   source={{uri:'http://thenewcode.com/assets/images/thumbnails/homer-simpson.svg'}}
                                    // />*/}
                                    //
                                    :
                                    //
                                    // <Image
                                    //     resizeMode={resizeMode ? resizeMode : "stretch"}
                                    //     style={[styleImage, {
                                    //         width: "100%",
                                    //         height: "100%",
                                    //         position: 'absolute',
                                    //         top: 0,
                                    //         bottom: 0,
                                    //         right: 0,
                                    //         left: 0,
                                    //         borderRadius: borderRadius ? moderateScale(borderRadius) : 0
                                    //     }]}
                                    //
                                    //    //   source={item.image ? item.image : {uri: this.state.source}}
                                    //       source={ {uri: this.state.source}}
                                    //   //  sourceeee={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.func_switch(item.id) : {uri: this.state.source}}
                                    //  //   source={item.id == 64 || item.id == 68 || item.id == 46 || item.id == 54 ? this.state.path : {uri: this.state.source}}
                                    // />
                                    //
                                    //
                                    //

                                    FastImage ?
                                        <FastImage
                                            onLoad={onLoad}
                                            onError={onError}
                                            // style={styles.image}
                                            tintColor={tintColor}
                                            style={[styleImage, {
                                                width: "100%",
                                                height: "100%",
                                                position: 'absolute',
                                                top: 0,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                borderRadius: borderRadius ? moderateScale(borderRadius) : 0,
                                                //  backgroundColor: this.state.loadImage ? Colors.transparent : _backgroundColorLoading ? _backgroundColorLoading : Colors.gray
                                            }]}
                                            onLoadEnd={(e) => {
                                                this.setState({
                                                    loadImage: true
                                                })
                                            }
                                            }
                                            resizeMode={resizeMode ? resizeMode : FastImage.resizeMode.contain}
                                            source={source_image ? source_image : {uri: this.props.uriComplete ? this.props.uriComplete : this.props.uriComplete == '' || this.props.uriComplete == null ? null : typeExport.baseUrlImage + this.props.uri}}
                                        />
                                        :
                                        <Image
                                            source={source_image ? source_image : {uri: this.props.uriComplete ? this.props.uriComplete : this.props.uriComplete == '' || this.props.uriComplete == null ? null : typeExport.baseUrlImage + this.props.uri}}
                                            resizeMode={resizeMode ? resizeMode : "contain"}
                                            tintColor={tintColor}
                                            style={[styleImage, {
                                                width: "100%",
                                                height: "100%",
                                                position: 'absolute',
                                                top: 0,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                borderRadius: borderRadius ? moderateScale(borderRadius) : 0,
                                                backgroundColor: this.state.loadImage ? Colors.transparent : _backgroundColorLoading ? _backgroundColorLoading : Colors.gray
                                            }]}

                                        />


                            }


                            {
                                text && text != null && text.length > 0 ? <HMTextView
                                        type={"bold"}

                                        style={[

                                            {
                                                position: 'absolute',
                                                bottom: 0,
                                            },
                                            {
                                                width: '100%',
                                                fontSize: moderateScale(13),
                                                //color: Colors.white,

                                                textAlign: 'center'
                                            },
                                            styleText,
                                        ]}

                                        text={text}
                                    />
                                    : null
                            }
                            {
                                item && item.status && item.status.length > 0 ? <HMTextView
                                        type={"bold"}

                                        style={[

                                            {
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                backgroundColor: Colors.white,
                                                borderRadius: moderateScale(8)
                                            },
                                            {
                                                width: '100%',
                                                fontSize: moderateScale(13),

                                                //color: Colors.white,

                                                textAlign: 'center'
                                            },
                                            styleText,
                                        ]}

                                        text={item.status}
                                    />
                                    : null
                            }

                        </View>
                }


            </View>
        );
    }

    //
    // func_switch(id) {
    //     switch (id) {
    //
    //         case 64 :
    //             //  return PathFile.image.News;
    //             this.setState({path: PathFile.image.News})
    //             break;
    //
    //         case 68 :
    //             // return  PathFile.image.Map;
    //             this.setState({path: PathFile.image.Map})
    //             break;
    //
    //         case 46 :
    //             //return PathFile.image.Restaurant;
    //             this.setState({path: PathFile.image.Restaurant})
    //             break;
    //
    //         case 54 :
    //             // return PathFile.image.Hotel;
    //             this.setState({path: PathFile.image.Hotel})
    //             break;
    //
    //         default :
    //         //item.thumbnail
    //         //    uriComplete = {item.thumbnail}
    //     }
    // }

}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashSatiaScreen,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(HMImageView);
